// Generated by BUCKLESCRIPT VERSION 4.0.18, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../Utils.js");
var React = require("react");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var ReactDOMRe = require("reason-react/lib/js/src/ReactDOMRe.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Caml_primitive = require("bs-platform/lib/js/caml_primitive.js");

function str(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("NewsColumns");

function unaCard($staropt$star, $staropt$star$1, $staropt$star$2, children) {
  var className = $staropt$star !== undefined ? $staropt$star : "";
  var border = $staropt$star$1 !== undefined ? $staropt$star$1 : "none";
  var flow = $staropt$star$2 !== undefined ? $staropt$star$2 : "vertical";
  return ReactDOMRe.createElementVariadic("div", {
              "data-border": border,
              "data-flow": flow,
              class: "una-card " + className
            }, children);
}

function unaCardTime(item) {
  return ReactDOMRe.createElementVariadic("time", {
              "data-color": "grayBlue"
            }, /* array */[
              item[/* date */0] + " | ",
              ReactDOMRe.createElementVariadic("a", {
                    href: item[/* editorialLink */6],
                    target: "_blank",
                    "data-color": "grayBlue"
                  }, /* array */[item[/* editorialTitle */4]])
            ]);
}

function unaCardTitle($staropt$star, $staropt$star$1, item) {
  var size = $staropt$star !== undefined ? $staropt$star : "small";
  var search = $staropt$star$1 !== undefined ? $staropt$star$1 : "";
  return ReactDOMRe.createElementVariadic("h3", {
              class: "una-card__title",
              "data-color": "darkBlue",
              "data-font-weight": "medium",
              "data-size": size
            }, /* array */[React.cloneElement(React.createElement("a", {
                        href: item[/* link */1],
                        target: "_blank",
                        dangerouslySetInnerHTML: {
                          __html: Utils.$$String[/* mark */0](item[/* title */2], search)
                        }
                      }), {
                    "data-color": "grayBlue"
                  })]);
}

function make(news, $staropt$star, param) {
  var search = $staropt$star !== undefined ? $staropt$star : "";
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function (param) {
              return React.createElement("div", {
                          className: "unp-news__columns row"
                        }, Utils.List[/* mapToElement */0]((function (param, editorial) {
                                var count = Caml_primitive.caml_int_min(3, Belt_List.size(editorial[/* items */1]));
                                var __x = editorial[/* items */1];
                                return React.createElement("div", {
                                            className: "unp-news__column"
                                          }, React.createElement("h3", undefined, editorial[/* label */0]), React.createElement("div", {
                                                className: "una-card-list"
                                              }, Utils.List[/* mapToElement */0]((function (idx, item) {
                                                      var match = idx === 0;
                                                      var match$1 = idx === 0;
                                                      var match$2 = idx === 0;
                                                      return React.createElement("div", {
                                                                  className: "una-card-wrapper"
                                                                }, unaCard(match ? "text-center" : "", undefined, match$1 ? "vertical" : "horizontal", /* array */[
                                                                      React.createElement("a", {
                                                                            className: "una-card__image",
                                                                            style: {
                                                                              backgroundImage: "url('" + (item[/* thumb */7] + "')")
                                                                            }
                                                                          }),
                                                                      React.createElement("div", {
                                                                            className: "una-card__content"
                                                                          }, unaCardTime(item), unaCardTitle(match$2 ? "small" : "extraSmall", search, item))
                                                                    ]));
                                                    }), Belt_Option.getExn(Belt_List.take(__x, count)))));
                              }), Belt_List.keep(news, (function (e) {
                                    return Belt_List.size(e[/* items */1]) > 0;
                                  }))));
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* jsElementWrapped */component[/* jsElementWrapped */13]
        ];
}

exports.str = str;
exports.component = component;
exports.unaCard = unaCard;
exports.unaCardTime = unaCardTime;
exports.unaCardTitle = unaCardTitle;
exports.make = make;
/* component Not a pure module */
